import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'
import { User } from '@/types/user'

import { IAction } from '../actions/action-helpers'
import { AdminUsersTypes, PermissionsTypes, TravelersTypes } from '../actions/actions.types'

export type AdminUsersState = ApplicationState['adminUsers']

function adminUsersReducer(state: AdminUsersState = new ImmutableMap(), action: IAction): AdminUsersState {
	switch (action.type) {
		case AdminUsersTypes.InviteUser.SUCCESS:
		case AdminUsersTypes.UpdateUser.SUCCESS: {
			const user = action.payload?.user ?? action.payload
			const userId = user?.id ?? action.requestPayload?.user?.id
			return userId ? state.set(userId, { ...(state.get(userId) ?? {}), ...user }) : state
		}
		case TravelersTypes.GetUser.SUCCESS:
			return state.set(action.payload.id, action.payload)
		case AdminUsersTypes.GetAllUsers.SUCCESS: {
			const hasParams = action.requestParams && Object.keys(action.requestParams).length > 0
			if (hasParams) {
				return (action.payload ?? []).reduce((newState: AdminUsersState, u: User) => newState.set(u.id, u), state)
			}
			return (action.payload ?? []).reduce(
				(newState: AdminUsersState, u: User) => newState.set(u.id, u),
				new ImmutableMap(),
			)
		}
		case AdminUsersTypes.AddUser.SUCCESS:
			return state.set(action.payload.id, action.payload)
		case AdminUsersTypes.RemoveUser.SUCCESS:
			return state.delete(action.requestPayload.id)
		case TravelersTypes.CreateTraveler.SUCCESS:
		case TravelersTypes.UpdateTraveler.SUCCESS:
			return state.updatePart(action.payload.user_id, (user) => ({
				traveler_profile: { ...user.traveler_profile, ...action.payload },
			}))
		case AdminUsersTypes.AddUserRole.SUCCESS:
			return state.updatePart(action.requestPayload.user.id, (user) => {
				return {
					user_roles: [
						...(user.user_roles ?? []).filter((ur) => ur.id !== action.requestPayload.userRole.id),
						action.payload,
					],
				}
			})
		case AdminUsersTypes.RemoveUserRole.SUCCESS:
			return state.updatePart(action.requestPayload.user.id, (user) => {
				return {
					user_roles: (user.user_roles ?? []).filter((ur) => ur.id !== action.requestPayload.userRole.id),
				}
			})
		case PermissionsTypes.AddPermission.SUCCESS:
			return state.updatePart(action.requestPayload.user.id, (user) => {
				return {
					user_permissions: [
						...(user.user_permissions ?? []).filter((up) => up !== action.requestPayload.permission),
						action.payload,
					],
				}
			})
		case PermissionsTypes.RemovePermission.SUCCESS:
			return state.updatePart(action.requestPayload.user.id, (user) => {
				return {
					user_permissions: (user.user_permissions ?? []).filter((up) => up !== action.requestPayload.permission),
				}
			})
	}
	return state
}

export default adminUsersReducer
